export const DocumentFlag = {
    ONBOARDING: 'ONBOARDING',
    ACCOUNT_VERIFY: 'ACCOUNT_VERIFY',
    BANK_VERIFY: 'BANK_VERIFY',
    AGENT_UPLOAD: 'AGENT_UPLOAD'
};
